<template>
  <b-modal
    id="availability-modal"
    title="Availability"
    size="lg"
    ok-title="Save"
    scrollable
  >
    <h4
      class="mb-4 green"
      style="margin-top: 45px;"
    >
      Working Hours
    </h4>
    <p>Select which days and timeframes you’re available for sessions.</p>
    <form-component>
      <div class="week-table">
        <div class="form-row hide-label">
          <div class="col-12 title-bar">
            <div class="left">
              Start Time:
            </div>
            <div class="right">
              End Time:
            </div>
          </div>
          <div class="col-12 day-row">
            <div class="title">
              <b>Monday</b>
            </div>
            <div class="left">
              <b>Start Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
            <div class="right">
              <b>End Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
          </div>
        </div>
        <div class="form-row hide-label">
          <div class="col-12 day-row">
            <div class="title">
              <b>Tuesday</b>
            </div>
            <div class="left">
              <b>Start Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
            <div class="right">
              <b>End Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
          </div>
        </div>
        <div class="form-row hide-label">
          <div class="col-12 day-row">
            <div class="title">
              <b>Wednesday</b>
            </div>
            <div class="left">
              <b>Start Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
            <div class="right">
              <b>End Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
          </div>
        </div>
        <div class="form-row hide-label">
          <div class="col-12 day-row">
            <div class="title">
              <b>Thursday</b>
            </div>
            <div class="left">
              <b>Start Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
            <div class="right">
              <b>End Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
          </div>
        </div>
        <div class="form-row hide-label">
          <div class="col-12 day-row">
            <div class="title">
              <b>Friday</b>
            </div>
            <div class="left">
              <b>Start Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
            <div class="right">
              <b>End Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
          </div>
        </div>
        <div class="form-row hide-label">
          <div class="col-12 day-row">
            <div class="title">
              <b>Saturday</b>
            </div>
            <div class="left">
              <b>Start Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
            <div class="right">
              <b>End Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
          </div>
        </div>
        <div class="form-row hide-label">
          <div class="col-12 day-row">
            <div class="title">
              <b>Sunday</b>
            </div>
            <div class="left">
              <b>Start Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
            <div class="right">
              <b>End Time:</b>
              <input-select
                id="time"
                v-model="time"
                v-validate="'required'"
                name="time"
                data-vv-name="time"
                data-vv-as="time"
                label="Time"
                type="select"
                placeholder="Time"
                required
                :error="errors.first('time')"
                :options="timeOptions"
              />
            </div>
          </div>
        </div>
      </div>
    </form-component>
    <hr>
    <h4 class="mb-4 green">
      Calendars
    </h4>
    <p>Sync your calendars in order to further define your availability.</p>
    <table class="table bm-table">
      <tbody>
        <tr>
          <td>
            Google Calendar
          </td>
          <td class="text-right">
            <font-awesome-icon
              :icon="['fas', 'check-circle']"
              class="icon alt"
            />
          </td>
        </tr>
        <tr>
          <td>
            iCal
          </td>
          <td class="text-right">
            <font-awesome-icon
              :icon="['fas', 'check-circle']"
              class="icon alt"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-ghost btn-wide new-calendar-button">
      <font-awesome-icon
        :icon="['fas', 'plus']"
        class="icon alt"
      />
      Add New Calendar
    </button>
  </b-modal>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'PendingModal',
  components: {
    FormComponent,
    InputSelect,
  },
  data() {
    return {
      time: 'Unavailable',
      timeOptions: {
        Option1: 'Unavilable',
        Option2: 'Time',
      },
    };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss">
#availability-modal {
  .week-table {
    margin-top: 40px;

    .day-row {
      .title {
        display: inline-block;
        vertical-align: top;
        width: 120px;
        line-height: 42px;

        b {
          font-weight: normal;
        }
      }

      .left {
        display: inline-block;
        vertical-align: top;
        width: calc(50% - 60px);
        padding-right: 10px;

        b {
          font-weight: normal;
          vertical-align: top;
          width: 100%;
          display: none;
        }
      }

      .right {
        display: inline-block;
        vertical-align: top;
        width: calc(50% - 60px);

        b {
          font-weight: normal;
          vertical-align: top;
          width: 100%;
          display: none;
        }
      }
    }

    .title-bar {
      padding-left: 125px;

      .left {
        width: 50%;
        display: inline-block;
        vertical-align: top;
      }

      .right {
        width: 50%;
        display: inline-block;
        vertical-align: top;
      }

      .left,
      .right {
        text-transform: uppercase;
        font-size: 14px;
        opacity: 0.75;
        margin-bottom: 15px;
      }
    }
  }

  .green {
    color: $green;
    font-size: 24px;
    margin-bottom: 15px !important;
  }

  .new-calendar-button {
    background: none;
    margin-top: 10px;
    width: auto !important;
    margin-bottom: 45px;

    i,
    svg {
      margin-right: 8px;
    }
  }

  .bm-table {
    tbody {
      tr {
        &:last-of-type {
          td {
            border-bottom: solid 1px rgba(white, 0.1);
          }
        }
      }
    }
  }

  p {
    opacity: 0.75;
    margin-bottom: 30px;
  }
}
</style>
